/**
 * Created by zhengyf on 2017/9/26
 */

;(function () {
    homeQuotationCtrl.$inject = ['PRICE_RELATED_DATA'];
    angular
        .module('DSSXAPP')
        .component('homeQuotation', {
            template:'<div class="international-home-quotation rfq-wrap"><div class="rfq-title c-b"><h2 class="f-l"><a href="javascript:;">Request for Quotation</a></h2><div class="sub-title f-l">Customization Service</div><div class="label"></div></div><div class="content-wrapper"><div class="right rfq-right-common"><div class="form"><div class="title">One Request, Multiple Quotes.</div><div class="row"><input placeholder="What are you looking for..." class="input f-input" ng-model="vm.d.subject" maxlength="128"></div><div class="row flex"><label><input placeholder="Quantity" class="input s-input" ng-model="vm.d.quantity" maxlength="128"></label> <label><select class="unit input" ng-options="unit for unit in vm.c.quantityUnitList" ng-model="vm.d.quantityUnit"></select></label></div><div class="row tip"><div>Select template type:</div><div><a href="javascript:;" class="ui-btn ui-btn-normal" ng-repeat="item in vm.d.typeList track by $index" ng-click="vm.f.initTypeList($index)" ng-class="{\'selected\': vm.d.curTypeIndex === $index}" ng-bind="item.name"></a></div></div><div><a href="javascript:;" class="ui-btn ui-btn-submit" ng-click="vm.f.goRequest()">Request for Quotation</a></div></div></div><div class="left d-p"></div></div></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: homeQuotationCtrl
        });

    function homeQuotationCtrl(PRICE_RELATED_DATA) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        vm.c = {
            quantityUnitList: PRICE_RELATED_DATA.QUANTITY_UNIT
        };

        vm.d = {
            subject: '',
            quantity: '',
            quantityUnit: vm.c.quantityUnitList[0],
            curTypeIndex: -1,
            typeList: [
                {
                    type: 'price',
                    name: 'Request price'
                },
                {
                    type: 'sample',
                    name: 'Request a sample'
                },
                {
                    type: 'detail',
                    name: 'Request quotation details'
                }
            ]
        };

        vm.f = {
            goRequest: goRequest,
            initTypeList: initTypeList
        };

        // ==============function===================

        function onInit() {
            console.log('[HomeQuotationCtrl init: ]');
            initTypeList(-1);
        }

        function bindingsOnChanges(changes) {

        }

        /**
         * 初始化typeList
         * @param index
         */
        function initTypeList(index) {
            vm.d.curTypeIndex = index in vm.d.typeList ? index : -1;
        }

        function goRequest() {
            window.open('/rfq-post.html?subject=' + vm.d.subject + '&quantity=' + vm.d.quantity
                + '&quantityunit=' + vm.d.quantityUnit + '&rfqtype=' + (vm.d.curTypeIndex === -1 ? '' : vm.d.typeList[vm.d.curTypeIndex].type));
        }
    }


})();
